<template>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-12">
        <indexHeader
          :title="$t('Products')"
          :description="$t('From here you can control your products')"
          :showExport="'true'"
          :exportLink="path + '/export/excel'"
          :showBarcode="'true'"
          :barcodePath="'productsBarcode'"
          :goldBarcodePath="'goldBarcode'"
          :showImport="'true'"
          :explanationPath="path + '/explaination'"
        />
        <indexTable
          :searchText="$t('Search for a product')"
          :emptyTableText="$t('There are no products')"
          :buttonRole="$checkRole('products_add')"
          :localData="true"
          :emptyTableSubText="$t('Try adding some items to the table and try again')"
          :cloumns="[
            {
              column: 'name',
              title: $t('Product name'),
              type: 'mainLink',
              sort: true
            },
            {
              column: 'code',
              title: $t('Product code'),
              type: 'text',
              sort: true,
              icon: 'file-code'
            },
            {
              column: 'barcode',
              title: $t('Barcode'),
              type: 'text',
              sort: true,
              icon: 'file-code'
            },
            {
              column: 'section_id',
              title: $t('Category'),
              type: 'link',
              to: 'section',
              sort: true,
              link: false,
              icon: 'folders'
            },
            {
              column: 'price',
              title: $t('Price'),
              type: 'text',
              sort: true,
              icon: 'usd-square'
            },
            {
              column: 'cost',
              title: $t('Cost'),
              type: 'text',
              sort: true,
              icon: 'dollar-sign'
            },
            {
              column: 'options',
              title: $t('Settings'),
              type: 'options',
              options: [
                { name: 'show' },
                {
                  name: 'edit',
                  role: $checkRole('customers_edit')
                },
                {
                  name: 'delete',
                  role: $checkRole('customers_delete')
                }
              ]
            }
          ]"
          :deleteText="{
            attention: $t('Attention'),
            areYouReallySureToDeleteTheItem: $t('Are you really sure to delete the product'),
            close: $t('Close'),
            confirm: $t('Confirm'),
            loading: $t('Loading')
          }"
        />
      </div>
    </div>
    <importForm v-if="importShow" />
  </div>
</template>
<script>
import indexHeader from '@/elements/index/indexHeader.vue'
import indexTable from '@/elements/index/indexTable.vue'

import importForm from './components/importForm.vue'

export default {
  data() {
    return {
      path: '/products',
      importShow: false
    }
  },
  methods: {
    importForm() {
      this.importShow = true
    }
  },
  components: {
    indexHeader,
    indexTable,
    importForm
  }
}
</script>
